import Svg from 'react-native-svg'

export const JioPay = ({ height, width }: { height: any; width: any }) => {
  return (
    <Svg id="Group_22" data-name="Group 22" width="40.036" height="20" viewBox="0 0 40.036 20">
      <text
        id="Pay"
        transform="translate(22.036 13.166)"
        fill="#0074b3"
        font-size="10"
        font-family="JioType-Bold, JioType"
        font-weight="700">
        <tspan x="0" y="0">
          Pay
        </tspan>
      </text>
      <g id="Symbols" transform="translate(0 0)">
        <g id="Images_Logos_JioPrime_Light" data-name="Images/Logos/JioPrime/Light">
          <g id="Group-2" transform="translate(0 0)">
            <g id="Group-9">
              <path
                id="Fill-4"
                d="M10.152.018a10.069,10.069,0,0,0-10.137,10,10.069,10.069,0,0,0,10.137,10,10.069,10.069,0,0,0,10.138-10,10.07,10.07,0,0,0-10.138-10"
                transform="translate(-0.015 -0.018)"
                fill="#0074b3"
              />
              <path
                id="Fill-7"
                d="M15.082,12.159a1.229,1.229,0,0,1-1.26-1.312,1.261,1.261,0,1,1,2.52.012,1.246,1.246,0,0,1-1.26,1.3m.023-4.293a2.918,2.918,0,0,0-3.185,2.981,2.877,2.877,0,0,0,3.15,3,2.9,2.9,0,0,0,3.173-2.992,2.9,2.9,0,0,0-3.138-2.992m-4.93-2.612A1.037,1.037,0,0,0,9,6.29c0,.644.467,1.047,1.213,1.047A1.04,1.04,0,0,0,11.388,6.29c0-.645-.467-1.036-1.213-1.036m.128,2.67H10.07c-.572,0-1,.265-1,1.07v3.683c0,.817.42,1.07,1.027,1.07h.233c.572,0,.98-.276.98-1.07V8.994c0-.828-.4-1.07-1-1.07M7.249,6.186H6.911c-.641,0-.992.357-.992,1.07V10.7c0,.886-.3,1.2-1.015,1.2a1.726,1.726,0,0,1-1.377-.679,1.154,1.154,0,0,0-.77,1.151c0,.921.875,1.485,2.5,1.485,1.972,0,3.01-.978,3.01-3.119V7.256c0-.713-.35-1.07-1.015-1.07"
                transform="translate(-0.087 -0.155)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </Svg>
  )
}
